import React from "react";

const cards = [
  { title: "Step 1", desc: "Start your KYC by clicking the button above." },
  { title: "Step 2", desc: "Verify your identity using official documents." },
  { title: "Step 3", desc: "Complete the video KYC with our agent." },
  { title: "Step 4", desc: "Confirmation will be sent after completion." },
];

const InfoCards = () => (
  <section
    style={{
      background:
        "linear-gradient(160deg, #071520 0%, #0a1e2e 35%, #071018 100%)",
      // Large top padding pushes cards well below the hero section
      paddingTop: "64px",
      paddingBottom: "72px",
      paddingLeft: "24px",
      paddingRight: "24px",
      width: "100%",
      boxSizing: "border-box",
    }}
  >
    {/* Section label */}
    <p
      style={{
        textAlign: "center",
        fontSize: "11px",
        fontWeight: 500,
        letterSpacing: "3px",
        textTransform: "uppercase",
        color: "rgba(64,190,180,0.6)",
        marginBottom: "32px",
      }}
    >
      How it works
    </p>

    <div
      style={{
        maxWidth: "1152px",
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: "24px",
      }}
    >
      {cards.map((card, idx) => (
        <div
          key={idx}
          style={{
            padding: "28px 24px",
            borderRadius: "18px",
            textAlign: "center",
            color: "#fff",
            background: "rgba(10, 25, 40, 0.92)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(64,190,180,0.2)",
            boxShadow: `
              0 0 0 1px rgba(255,255,255,0.03) inset,
              0 15px 40px rgba(0,0,0,0.5),
              0 0 25px rgba(64,190,180,0.05)
            `,
            transition: "transform 0.2s, box-shadow 0.2s",
            cursor: "default",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow =
              "0 0 0 1px rgba(255,255,255,0.04) inset, 0 20px 50px rgba(0,0,0,0.6), 0 0 35px rgba(64,190,180,0.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              "0 0 0 1px rgba(255,255,255,0.03) inset, 0 15px 40px rgba(0,0,0,0.5), 0 0 25px rgba(64,190,180,0.05)";
          }}
        >
          {/* Step number badge */}
          <div
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              background: "rgba(64,190,180,0.12)",
              border: "1px solid rgba(64,190,180,0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
              fontSize: "14px",
              fontWeight: 700,
              color: "#40BEB4",
            }}
          >
            {idx + 1}
          </div>

          <h3
            style={{
              fontSize: "17px",
              fontWeight: 600,
              color: "#40BEB4",
              marginBottom: "10px",
            }}
          >
            {card.title}
          </h3>
          <p style={{ color: "rgba(255,255,255,0.55)", fontSize: "13px", lineHeight: "1.6" }}>
            {card.desc}
          </p>
        </div>
      ))}
    </div>
  </section>
);

export default InfoCards;
